import React from 'react'
import { StyleProp, ViewStyle } from 'react-native'
import styled from 'styled-components/native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { isWeb } from 'APP/Helpers/checkPlatform'

// Components
import AppointmentBooking, { AppointmentBookingProps } from 'APP/Components/AppointmentBooking'

export const Container = styled(SafeAreaView).attrs({
  edges: ['bottom', 'left', 'right'],
})`
  flex: 1;
  padding: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const ContentContainer = styled.View`
  flex: 1;
  overflow: hidden;
  border-radius: ${({ theme }) => (isWeb() ? theme.metrics.borderRadius.medium : 0)}px;
`

interface IntakeBookingProps extends AppointmentBookingProps {
  style?: StyleProp<ViewStyle>
  title: string
}

const IntakeBooking = ({ style, title, ...rest }: IntakeBookingProps) => {
  return (
    <Container style={style} testID="INTAKE_BOOKING_CONTAINER">
      <ContentContainer>
        <AppointmentBooking {...rest} />
      </ContentContainer>
    </Container>
  )
}

export default IntakeBooking
